<div
    fxLayout="column"
    class="models-dialog-component gap-16 padding-12 full-height"
>
    <div
        fxLayout="row"
        class="models-dialog-component__header"
        fxLayoutAlign="space-between center"
    >
        <h1 class="text-16-semi-bold color-text-primary">
            {{ data.title }}
        </h1>
        <dsn-button-menu-chips
            [mainIcon]="'fa-solid fa-xmark'"
            size="medium"
            (onClick)="this.dialogRef.close()"
        ></dsn-button-menu-chips>
    </div>
    <div
        class="models-dialog-component__description"
        fxLayout="column"
        fxLayoutAlign="start none"
    >
        <p class="text-16-semi-bold color-text-primary">
            {{ data.description }}
        </p>
    </div>
    <div
        fxLayout="column"
        class="models-dialog-component__section padding-12 full-height"
        fxLayoutAlign="center center"
        fxFlex
    >
        <img
            [src]="data.image.src"
            [style.width]="data.image.width"
            [style.maxHeight]="data.image.height"
            [alt]="data.title"
        />
    </div>
</div>
